import React, { useState, useEffect, useContext } from 'react';
import { DataTable, Notifications } from '../../../shared';
import { fbmApi as api } from '../../../api/fbm';
import { UserContext } from '../../../contexts/UserContext';
import { Button, CircularProgress } from '@material-ui/core';

let ViewFBMUserAccounts = () => {
    let [rows, setRows] = useState([]);
    let [notification, setNotification] = useState({ text: null, level: null });
    let [loadingStates, setLoadingStates] = useState({});
    const { fbmAccount, user } = useContext(UserContext);

    let getRows = async () => {
        let response = await api.getUserAccounts(fbmAccount.fbmAccountName);

        if (response.status === false) {
            setNotification({ text: "Can't access Accounts: " + response.msg, level: 'error' });
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        if (fbmAccount?.id) {
            getRows();
        }
    }, [fbmAccount]);

    let columns = [
        { accessor: 'id', Header: 'User ID' },
        { accessor: 'firstName', Header: 'First Name' },
        { accessor: 'lastName', Header: 'Last Name' },
        { accessor: 'email', Header: 'Email' },
        {
            accessor: 'resetpw',
            Header: 'Reset Password',
            Cell: ({ cell: { value: initialValue }, row, column, saveEdit, editable }) => {
                const isLoading = loadingStates[`reset_${row.original.id}`];

                return (
                    <Button
                        id={`ResetPW_${row.id}`}
                        disabled={isLoading}
                        onClick={async () => {
                            const loadingKey = `reset_${row.original.id}`;
                            setLoadingStates((prev) => ({ ...prev, [loadingKey]: true }));

                            try {
                                let response = await api.resetFBMUserPassword(row.original.id);

                                if (response.status === false) {
                                    setNotification({
                                        text: "Can't reset password for user " + response.msg,
                                        level: 'error',
                                    });
                                    return;
                                }
                                setNotification({ text: 'User password reset', level: 'success' });
                                getRows();
                            } finally {
                                setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
                            }
                        }}
                    >
                        {isLoading ? <CircularProgress size={20} /> : 'Reset Password'}
                    </Button>
                );
            },
        },
        {
            accessor: 'delete',
            Header: 'Delete',
            Cell: ({ cell: { value: initialValue }, row, column, saveEdit, editable }) => {
                const isLoading = loadingStates[`delete_${row.original.id}`];

                return (
                    <Button
                        id={`Delete_${row.id}`}
                        disabled={isLoading}
                        onClick={async () => {
                            const loadingKey = `delete_${row.original.id}`;
                            setLoadingStates((prev) => ({ ...prev, [loadingKey]: true }));

                            try {
                                let response = await api.deleteFBMUserAccount(row.original.id);

                                if (response.status === false) {
                                    setNotification({ text: "Can't remove user " + response.msg, level: 'error' });
                                    return;
                                }
                                setNotification({ text: 'User removed', level: 'success' });
                                getRows();
                            } finally {
                                setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
                            }
                        }}
                    >
                        {isLoading ? <CircularProgress size={20} /> : 'Remove'}
                    </Button>
                );
            },
        },
    ];

    return (
        <div>
            <h1>{fbmAccount.companyName} - User Accounts</h1>
            <Notifications options={notification} />
            {}
            <div>
                <DataTable columns={columns} data={rows} />
            </div>
        </div>
    );
};

export { ViewFBMUserAccounts };
